/* global axios */
import ApiClient from './ApiClient';

class BillingAPI extends ApiClient {
  constructor() {
    super('billing', { accountScoped: true });
  }

  createCheckout({ planName, paymentMethod }) {
    return axios.post(this.url, {
      plan_name: planName,
      payment_method: paymentMethod,
    });
  }
}

export default new BillingAPI();
